import React from 'react';
import { Switch, Route } from 'react-router-dom'
import ReduxToastr from 'react-redux-toastr';
import { CookiesProvider } from 'react-cookie';
import 'babel-polyfill';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import CookieConsentBar from '../../components/CookieConsentBar';
import asyncComponent from '../../components/AsyncComponent';
import PrivateRoute from '../../components/PrivateRoute';
import RedirectHome from '../../components/RedirectHome';

import '../../assets/css/ionicons.min.css';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';

import './reset.css';
import './grid.css';
import './flow.css';

const Marketing = asyncComponent(() => import('../Marketing'));
const Development = asyncComponent(() => import('../Development'));
const Property = asyncComponent(() => import('../Property'));
const Profile = asyncComponent(() => import('../Profile'));
const Registration = asyncComponent(() => import('../Registration'));
const Register = asyncComponent(() => import('../Register'));
const NotFound = asyncComponent(() => import('../NotFound'));
const ResetPassword = asyncComponent(() => import('../ResetPassword'));
const TermsAndConditions = asyncComponent(() => import('../TermsAndConditions'));
const CookiePolicy = asyncComponent(() => import('../CookiePolicy'));
const PrivacyPolicy = asyncComponent(() => import('../PrivacyPolicy'));
const AcceptableUsePolicy = asyncComponent(() => import('../AcceptableUsePolicy'));

const App = () => (
  <CookiesProvider>
    <div className="main">
      <Header />
      <Switch>
        <Route exact path="/" className="content" component={Marketing} />
        <Route exact path="/development" className="content" component={Development} />
        <Route path="/register/:key" className="content" component={Register} />
        <Route path="/register" className="content" component={Registration} />
        <Route path="/terms" className="content" component={TermsAndConditions} />
        <Route path="/cookie-policy" className="content" component={CookiePolicy} />
        <Route path="/privacy" className="content" component={PrivacyPolicy} />
        <Route path="/acceptable-use" className="content" component={AcceptableUsePolicy} />
        <Route path="/property/:hashId" className="content" component={Property} />
        <PrivateRoute path="/profile" className="content" component={Profile} unauthorisedComponent={RedirectHome} />
        <Route path="/reset" component={ResetPassword} />
        <Route path="*" component={NotFound} />
      </Switch>
      <Footer className="footer" />    
      <CookieConsentBar />
      <ReduxToastr position="bottom-right" />
    </div>
  </CookiesProvider>
);


export default App;



// WEBPACK FOOTER //
// ./src/containers/App/App.jsx